export default __webpack_public_path__ + "static/media/qr.4a00e855.png";